import { useState, useEffect } from 'react';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';

function Admin() {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const password = localStorage.getItem('admin_password');
    if (password === 'admin123') {
      setAuthenticated(true);
    }
    document.title = 'NASCAR — Админ-панель';
  }, []);

  const handleLogin = () => setAuthenticated(true);
  const handleLogout = () => {
    localStorage.removeItem('admin_password');
    setAuthenticated(false);
  };

  return authenticated ? (
    <AdminDashboard onLogout={handleLogout} />
  ) : (
    <AdminLogin onLogin={handleLogin} />
  );
}

export default Admin;
